module.exports = __webpack_public_path__ + "f75a363b0facdd7c93f2bec2fefee2dd.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader!./assets/notification-sound.mp3
 ** module id = 7
 ** module chunks = 0
 **/